'use strict';

module.exports = '_sugar_';


//////////////////
// WEBPACK FOOTER
// ./~/sugar/common/var/PRIVATE_PROP_PREFIX.js
// module id = 463
// module chunks = 0